import axios from '../axios';
import EventBus from 'eventing-bus';
import { all, takeLatest, takeEvery, call, put } from 'redux-saga/effects';
import { setLeads, setRevealedLeads, setLeadsError, setLeadsCredits, setInCrmMap, setLeadsFilterOptions } from './index';

function* getCall(path) {
  try {
    return { response: yield call(() => axios.get(path)) }
  } catch (error) { return { error }; }
}

function* postCall({ path, payload }) {
  try {
    return { response: yield call(() => axios.post(path, payload)) }
  } catch (error) { return { error }; }
}

function* searchLeads({ payload }) {
  const params = new URLSearchParams();
  // Reason: array filters serialize as repeated keys (no comma-join — values may contain commas)
  Object.entries(payload || {}).forEach(([k, v]) => {
    if (Array.isArray(v)) v.forEach(x => { if (x !== '' && x != null) params.append(k, x); });
    else if (v !== '' && v !== false && v != null) params.append(k, v);
  });
  const { response, error } = yield call(getCall, `/leads/search?${params.toString()}`);
  if (error) {
    yield put(setLeadsError(error?.['response']?.['data']?.['message'] || 'Search failed'));
  } else if (response) {
    // Reason: single API call → single dispatch. SET_LEADS reducer unpacks records + inCrmMap + revealed atomically.
    yield put(setLeads(response['data']['body'] || {}));
  }
}

function* revealLeads({ payload }) {
  const { onSuccess, ...body } = payload || {};
  const { response, error } = yield call(postCall, { path: '/leads/reveal', payload: body });
  if (error) {
    yield put({ type: 'SET_REVEAL_LOADING', payload: false });
    EventBus.publish('error', error?.['response']?.['data']?.['message'] || 'Reveal failed');
  } else if (response) {
    const respBody = response['data']['body'] || {};
    yield put(setRevealedLeads(respBody));
    // Reason: /reveal returns new balance inline — no follow-up /credits call needed
    if (respBody['creditsBalance'] != null) yield put(setLeadsCredits(respBody['creditsBalance']));
    // Reason: backend auto-syncs every reveal into Contacts — flip inCrmMap so the "Added to Contacts" icon appears immediately
    const ids = body['prospectIds'] || [];
    if (ids.length) yield put(setInCrmMap(Object.fromEntries(ids.map(id => [id, true]))));
    if (onSuccess) onSuccess(respBody);
  }
}

function* getLeadsCredits() {
  const { response } = yield call(getCall, '/leads/credits');
  if (response) yield put(setLeadsCredits(response['data']['body']?.['creditsBalance'] || 0));
}

function* getLeadsFilterOptions() {
  const { response, error } = yield call(getCall, '/leads/filter-options');
  if (error) yield put(setLeadsFilterOptions(null));
  else if (response) yield put(setLeadsFilterOptions(response['data']['body'] || null));
}

export default function* leadsSaga() {
  yield all([
    takeLatest('SEARCH_LEADS', searchLeads),
    takeEvery('REVEAL_LEADS', revealLeads),
    takeLatest('GET_LEADS_CREDITS', getLeadsCredits),
    takeLatest('GET_LEADS_FILTER_OPTIONS', getLeadsFilterOptions),
  ]);
}
